import React, {useState, useContext, useEffect} from "react"
import {useHistory} from 'react-router-dom'
import '../../css/pages/MapPage.css'
import '../../css/animations.css'

import useMapLocations from '../../hooks/useMapLocations'
import useTogglePopUp from '../../hooks/useTogglePopUp'
import {PlayerStatsContext} from '../../context/PlayerStatsContext'
import {UnmountContextProvider} from '../../context/UnmountContext'

import GameHeader from '../../components/GameHeader'
import BrassPanel from '../../components/BrassPanel'
import PaperPanel from '../../components/PaperPanel'
import InfoPopUp from '../../components/InfoPopUp'
import OptionsMenu from '../../components/OptionsMenu'

import LocationListItem from './LocationListItem'
import MapMarker from './MapMarker'

function MapPage() {
    const [popUpContent, setPopUpContent] = useState('')
    const [{locations, hovered}, toggleHover] = useMapLocations()
    const {isPopUpOpen, togglePopUp, isMenuOpen, openMenu} = useTogglePopUp()
    const {playerStats, gameSaved, setGameSaved} = useContext(PlayerStatsContext)
    const route = useHistory()
        
    function locationProps(location) {
        const {name, logo, text} = location
        
        return {
            logo: logo,
            name: name,
            text: text,
            hover: hovered.[name],
            status: playerStats.[name],
            toggleHover: toggleHover
        }
    }
    
    function requestLocation(name, status) {
        if (status === 'locked') {
            togglePopUp()
            setPopUpContent("You don't have enough evidence to head there yet.")
        } else if (status === 'complete') {
            togglePopUp()
            setPopUpContent('You have already investigated this location.')
        } else {
            route.push(`/location/${name}/story`)
        }
    }
    
    useEffect(() => {
        if (gameSaved) {
            setPopUpContent('Your progress has been saved.')
            togglePopUp()
            setGameSaved(false)
        }
    }, [gameSaved, togglePopUp, setGameSaved])
                
    return (
        <div className="pageContainer pageContainer-map">
            <GameHeader>
                <p className='header_link' onClick={openMenu}>
                    <i className="fas fa-cog"></i> options menu
                </p>
            </GameHeader>
            
            <aside className="mapSide">
                <BrassPanel extraClasses='mapSide_head'>
                    <h2 className="">Choose a location to investigate</h2>
                </BrassPanel>
                
                <PaperPanel extraClasses='mapSide_locationList'>
                    <ul>
                        {locations.map((location, index) => {
                            const props = locationProps(location)
                            return <LocationListItem key={index} location={props} requestLocation={requestLocation}/>
                        })}
                    </ul>
                </PaperPanel>
            </aside>
            
            <BrassPanel extraClasses='mapHeader_subTitle' small>
                <p><em>Choose a location to investigate</em></p>
            </BrassPanel>
            
            <main className="main-map">
                <PaperPanel extraClasses='mapContainer'>
                    {locations.map((location, index) => {
                        const props = locationProps(location)
                        return <MapMarker key={index} location={props} requestLocation={requestLocation}/>
                    })}
                </PaperPanel>
                
                <UnmountContextProvider>
                    <InfoPopUp isPopUpOpen={isPopUpOpen} togglePopUp={togglePopUp}>
                        
                        {isMenuOpen ?
                            <OptionsMenu /> : <div className="infoPopUp_text">{popUpContent}</div>
                        }
                        
                    </InfoPopUp>
                </UnmountContextProvider>
            </main>
        </div>
    )
}

export default MapPage